// extracted by mini-css-extract-plugin
module.exports = {"container":"BannerImage_container__tEymj","container__color":"BannerImage_container__color__1-sZ0","buttonBG":"BannerImage_buttonBG__2P-E8"};